<template>
  <div>
    <v-row no-gutters class="form-group" v-if="![undefined, null, ''].includes(label)">
      <span class="item-label">{{ label }}</span>
    </v-row>
    <v-radio-group
      label=""
      v-bind="computedProps"
      v-on="computedListeners"
    >
      <slot>
      <!-- 任意設定エリア -->
      </slot>
    </v-radio-group>
  </div>
</template>
<script>
import controls from '@/rahmen/controls'
import inputMixin from '@/mixins/inputMixins'
import { VRadio } from 'vuetify/lib'

/**
 * @file DDv2用ラジオボタン
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-radio/
 * @example
  <v-radio-group v-model="radioGroup">
    <dd-radio-button
      label="C#"
      value="C#"
    />
    <dd-radio-button
      label="javascript"
      value="javascript"
    />
    <dd-radio-button
      label="SQL"
      value="SQL"
    />
  </v-radio-group>
 */
export default {
  name: 'DdRadioGroup',
  extends: VRadio,
  mixins: [inputMixin],
  props: {
    /**
     * ラベル
     */
    label: String,
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String
  },
  data: () => ({
    invalidMessage: ''
  }),
  created () {
  },
  mounted () {
    this.invalidMessage = this.errorMessages
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        // backgroundColor: this.required ? controls.Colors.Required : '',
        class: this.required ? ' required-item' : this.class,
        row: true,
        dense: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    hasError () {
      return this.invalidMessage
    }
  },
  methods: {
    [controls.FORMAT_METHOD]: function () {
    }
  }
}
</script>
<style scoped>
</style>
